import React from "react";
import intl from "react-intl-universal";
import { mdiCheck } from "@mdi/js";

import { Grid } from "../../../../../components/Grid";
import { Button } from "../../../../../components/Button";
import { Output } from "../../../../../components/Output";
import { Dialog } from "../../../../../containers/Dialog";
import { DialogBody } from "../../../../../containers/DialogBody";
import { DialogFooter } from "../../../../../containers/DialogFooter";

export const IxusResultTransformDialog = props => {
    const { transform } = props;

    return (
        <Dialog
            width="400px"
            closeIcon={false}
            title={intl.get("entry.ixus.main.transformTitle")}
            onClose={() => props.onClose()}>
            <DialogBody>
                <Grid template="1fr 100px">
                    <div>{intl.get("entry.ixus.main.offsetX")}</div>
                    <Output type="decimal" fractionDigits={3} textAlign="right" value={transform.offsetX} />
                    <div>{intl.get("entry.ixus.main.offsetY")}</div>
                    <Output type="decimal" fractionDigits={3} textAlign="right" value={transform.offsetY} />
                    <div>{intl.get("entry.ixus.main.scaleX")}</div>
                    <Output type="decimal" fractionDigits={4} textAlign="right" value={transform.scaleX} />
                    <div>{intl.get("entry.ixus.main.scaleY")}</div>
                    <Output type="decimal" fractionDigits={4} textAlign="right" value={transform.scaleY} />
                </Grid>
            </DialogBody>
            <DialogFooter>
                <Button
                    svgIcon={mdiCheck}
                    value={intl.get("common.ok")}
                    onClick={() => props.onClose()} />
            </DialogFooter>
        </Dialog>
    );
};
